export const DEFAULT_COLOR_BG = 'rgba(75, 192, 192, 0.2)'
export const COLOR_BG = {
    1: 'rgba(75, 192, 192, 0.2)',
    2: 'rgba(54, 162, 235, 0.2)',
    3: 'rgba(255, 206, 86, 0.2)',
    4: 'rgba(224, 176, 255, 0.2)',
    5: 'rgba(153, 102, 255, 0.2)',
    6: 'rgba(255, 99, 132, 0.2)',
    7: 'rgba(17, 212, 82, 0.2)',
    8: 'rgba(255, 236, 227, 0.2)',
    9: 'rgba(222, 255, 160, 0.2)',
    10: 'rgba(255, 125, 125, 0.2)',
    11: 'rgba(249, 224, 224, 0.2)',
}
export const DEFAULT_COLOR_BG_BORDER = 'rgba(75, 192, 192, 1)'
export const COLOR_BG_BORDER = {
    1: 'rgba(75, 192, 192, 1)',
    2: 'rgba(54, 162, 235, 1)',
    3: 'rgba(255, 206, 86, 1)',
    4: 'rgba(224,176,255, 1)',
    5: 'rgba(153, 102, 255, 1)',
    6: 'rgba(255, 99, 132, 1)',
    7: 'rgba(17,212,82,1)',
    8: 'rgba(255,236,227,1)',
    9: 'rgba(222,255,160,1)',
    10: 'rgba(255,125,125,1)',
    11: 'rgba(249, 224, 224, 1)',
}